module.exports = __webpack_public_path__ + "static/IMG-2355-e93476b3b9caf16746dad44247972581.jpg";